import { API_BASE_URL, API_GETWAY } from '../config';
import axios from 'axios';
import { FUNCTION_NAMES } from '../constants';
import { fetchWithRetry } from './tourUtils';

// Get device capabilities
export const getDeviceCapabilities = () => {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('experimental-webgl') || canvas.getContext('webgl');

  let maxTextureSize = 8192; // Default safe value

  if (gl) {
    try {
      maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
      const extension = gl.getExtension('WEBGL_lose_context');
      if (extension) extension.loseContext();
    } catch (error) {
      console.warn('WebGL capability detection failed:', error);
    }
  } else {
    console.warn('WebGL not supported on this device.');
  }

  console.log('Device WebGL capabilities:', {
    maxTextureSize,
    maxWidth: maxTextureSize,
  });

  return {
    maxWidth: maxTextureSize,
  };
};
export const getImageUrls = async (imageKeys, batchSize = 3) => {
  if (!Array.isArray(imageKeys) || imageKeys.length === 0) return [];

  const deviceCapabilities = getDeviceCapabilities();
  const { maxWidth } = deviceCapabilities;

  const allUrls = [];

  // Helper to split array into chunks
  const chunkArray = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
      arr.slice(i * size, i * size + size)
    );

  const batches = chunkArray(imageKeys, batchSize);

  for (const batch of batches) {
    try {
      const response = await fetchWithRetry({
        url: `${API_BASE_URL}/api/post`,
        retries: 2,
        data: {
          function_name: FUNCTION_NAMES.POST.GET_S3_KEY,
          payload: {
            keys: batch,
            maxWidth: maxWidth,
          },
        },
        label: 'get s3 keys batch',
      });

      console.log('Batch response:', response);
      // debugger;
      const urls = response.urls || [];
      allUrls.push(...urls); // Append to final list
    } catch (error) {
      console.error('Error getting image URLs for batch:', error);
    }
  }

  return allUrls;
};
// Create image URL with device capabilities
// export const getImageUrl = async imageKey => {
//   // debugger;
//   const deviceCapabilities = getDeviceCapabilities();
//   if (!imageKey) return '';
//
//   try {
//     const baseUrl = `${API_BASE_URL}/api/s3`;
//     if (!deviceCapabilities) return baseUrl;
//
//     const { maxWidth } = deviceCapabilities;
//     const response = await axios
//       .post(
//         `${API_BASE_URL}/api/post`,
//         {
//           function_name: FUNCTION_NAMES.POST.GET_S3_KEY,
//           payload: {
//             key: imageKey,
//             maxWidth: maxWidth,
//           },
//         },
//         { headers: { 'Content-Type': 'application/json' } }
//       )
//       .catch(error => {
//         console.error('Axios error:', error.response?.data || error.message);
//         console.error('Status:', error.response?.status);
//         console.error('Headers:', error.response?.headers);
//         throw error;
//       });
//     console.log(imageKey, response);
//     return response.data.url;
//   } catch (error) {
//     console.error('Error getting image URL:', error);
//     return '';
//   }
// };
// Extract timestamp from the image filename
export const extractTimestamp = filename => {
  const match = filename.match(/IMG_(\d{8})_(\d{6})/);
  if (match) {
    const dateStr = match[1]; // Date (YYYYMMDD)
    const timeStr = match[2]; // Time (HHMMSS)
    const formattedDate = `${dateStr.slice(6, 8)}.${dateStr.slice(4, 6)}.${dateStr.slice(2, 4)}`; // Date (DD.MM.YY)
    const formattedTime = `${timeStr.slice(0, 2)}:${timeStr.slice(2, 4)}:${timeStr.slice(4, 6)}`; // Time (HH:MM:SS)
    return { date: formattedDate, time: formattedTime };
  }
  return { date: 'Unknown', time: 'Unknown' };
};
export const parseTimestamp = ts => {
  const [day, month, year] = ts.date.split('.');
  const fullDateStr = `20${year}-${month}-${day}T${ts.time}`; // ISO format
  return new Date(fullDateStr);
};
